import React, { FC } from 'react';
import { QuoteHighlightingToolbar, TQuoteHighlightingToolbarProps } from './QuoteHighlightingToolbar';
import { useT2Query } from '../../hooks/useT2Query';
import getArticleDataById from '../Article/queries/getArticleDataById';

type TQuoteHighlightingToolbarContainerProps = {
  articleId: TQuoteHighlightingToolbarProps['articleId'];
  pickedHighlightData: TQuoteHighlightingToolbarProps['pickedHighlightData'];
  modalContainer: TQuoteHighlightingToolbarProps['modalContainer'];
};

export const QuoteHighlightingToolbarContainer: FC<TQuoteHighlightingToolbarContainerProps> = ({
  articleId,
  pickedHighlightData,
  modalContainer,
}) => {
  const { data } = useT2Query(getArticleDataById, {
    returnPartialData: true,
    variables: { articleId },
  });
  const { article } = data || {};
  if (!article) {
    return;
  }

  const props = {
    articleId,
    pickedHighlightData,
    articleTitle: article?.title,
    author: article?.author,
    articleSlug: article?.slug,
    coverImage: article?.coverImage,
    modalContainer,
  };

  return <QuoteHighlightingToolbar {...props} />;
};
